// extracted by mini-css-extract-plugin
export default {"separator":"separator_separator__34TsT","light":"separator_light__dm6MF","dark":"separator_dark__SPm8Z"};